import * as loginFrontend from '@wisory-international-ab/login-frontend';

const { getToken, setToken, removeToken } = loginFrontend;

export { getToken, setToken, removeToken };
